import { useProductDesyncValidator } from '@backmarket/nuxt-layer-recommendation/composables/useProductDesyncValidator'

import { useFetchPickers } from '~/scopes/product-core/composables/useFetch/useFetchPickers/useFetchPickers'

export function useProductPageDesyncDetection() {
  const { isOutOfStock, selectedOffer } = useFetchPickers()

  useProductDesyncValidator(
    selectedOffer.value?.offerId ?? '',
    selectedOffer.value?.price?.amount ?? '',
    isOutOfStock.value,
  )
}
